import { render, staticRenderFns } from "./TotalValuesWidget.vue?vue&type=template&id=4d45f8ec&scoped=true"
import script from "./TotalValuesWidget.vue?vue&type=script&lang=js"
export * from "./TotalValuesWidget.vue?vue&type=script&lang=js"
import style0 from "./TotalValuesWidget.vue?vue&type=style&index=0&id=4d45f8ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d45f8ec",
  null
  
)

export default component.exports